import styled from 'styled-components';
import DefaultHeader from 'components/Header';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
`;

export const Header = styled(DefaultHeader)``;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;
